import { render } from "./NewsSmallItem.vue?vue&type=template&id=3cb903b5"
import script from "./NewsSmallItem.vue?vue&type=script&lang=js"
export * from "./NewsSmallItem.vue?vue&type=script&lang=js"

import "./NewsSmallItem.vue?vue&type=style&index=0&id=3cb903b5&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__